<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-6">
        <table>
          <td style="vertical-align: middle;"><img src="assets/img/global/despesa-prevista.png" alt="" title=""
              width="42" height="42">
          </td>
          <td>
            <p
              [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
              DESPESAS ORÇAMENTÁRIAS MENSAIS</p>
            <p
              [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
              EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
          </td>
        </table>
      </div>
      <div class="col-6">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair"
            [height]="sistema === 'transparencia' ? 30 : 20" [width]="sistema === 'transparencia' ? 30 : 20">
        </a>
        <a *ngIf="sistema === 'transparencia'" (click)="exportarListagem('xlsx')"
          class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_xls.png" alt="xls" title="gerar xls" height="30" width="30">
        </a>
        <a *ngIf="sistema === 'transparencia'" (click)="exportarListagem('pdf')"
          class="btn btn-sm btn-outline-secondary float-right ml-4">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="30" width="30">
        </a>
        <lib-export-list *ngIf="sistema !== 'transparencia'" (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <div class="row  mt-1">
      <div class="col-md">
        <table class="table table-eddy" style="font-size:11px">
          <thead>
            <tr>
              <th scope="col" class="text-left">Despesa</th>
              <th scope="col" class="text-right">Janeiro</th>
              <th scope="col" class="text-right">Fevereiro</th>
              <th scope="col" class="text-right">Março</th>
              <th scope="col" class="text-right">Abril</th>
              <th scope="col" class="text-right">Maio</th>
              <th scope="col" class="text-right">Junho</th>
              <th scope="col" class="text-right">Julho</th>
              <th scope="col" class="text-right">Agosto</th>
              <th scope="col" class="text-right">Setembro</th>
              <th scope="col" class="text-right">Outubro</th>
              <th scope="col" class="text-right">Novembro</th>
              <th scope="col" class="text-right">Dezembro</th>
              <th scope="col" class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPlanilha">
              <td class="text-left">
                <span [ngStyle]="{'margin-left': (+item.nivel * 5) + 'px'}">{{item.codigo}} - {{item.nome}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(1, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_jan > 0">
                  {{item.empenhado_jan | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_jan">{{item.empenhado_jan | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(2, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_fev > 0">
                  {{item.empenhado_fev | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_fev">{{item.empenhado_fev | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(3, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_mar > 0">
                  {{item.empenhado_mar | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_mar">{{item.empenhado_mar | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(4, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_abr > 0">
                  {{item.empenhado_abr | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_abr">{{item.empenhado_abr | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(5, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_mai > 0">
                  {{item.empenhado_mai | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_mai">{{item.empenhado_mai | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(6, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_jun > 0">
                  {{item.empenhado_jun | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_jun">{{item.empenhado_jun | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(7, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_jul > 0">
                  {{item.empenhado_jul | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_jul">{{item.empenhado_jul | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(8, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_ago > 0">
                  {{item.empenhado_ago | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_ago">{{item.empenhado_ago | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(9, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_set > 0">
                  {{item.empenhado_set | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_set">{{item.empenhado_set | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(10, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_out > 0">
                  {{item.empenhado_out | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_out">{{item.empenhado_out | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(11, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_nov > 0">
                  {{item.empenhado_nov | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_nov">{{item.empenhado_nov | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                <a class="link-nivel" target="_blank" (click)="redirecionarEmpenho(12, item.codigo)"
                  *ngIf="+item.nivel >= 4 && +item.empenhado_dez > 0">
                  {{item.empenhado_dez | number:'1.2-2'}}
                </a>
                <span *ngIf="4 > +item.nivel || 0 >= +item.empenhado_dez">{{item.empenhado_dez | number:'1.2-2'}}</span>
              </td>
              <td class="text-right">
                {{+item.empenhado_jan + +item.empenhado_fev + +item.empenhado_mar + +item.empenhado_abr +
                +item.empenhado_mai + +item.empenhado_jun + +item.empenhado_jul + +item.empenhado_ago +
                +item.empenhado_set + +item.empenhado_out + +item.empenhado_nov + +item.empenhado_dez | number:'1.2-2'}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>